import { useMemo } from "react";

export function useSalesData(objects) {
  return useMemo(() => {
    return objects
      ?.filter((obj) => obj.status === "C")
      .reduce((acc, obj) => {
        const parsedMonth = new Date(obj.tran_date).toLocaleString("default", {
          month: "long",
        });
        const parsedYear = new Date(obj.tran_date).getFullYear().toString();
        const monthYear = `${parsedMonth} ${parsedYear}`;
        const total = parseFloat(obj.total || 0);

        if (!acc[monthYear]) acc[monthYear] = { sales: 0 };
        acc[monthYear].sales += total;
        return acc;
      }, {});
  }, [objects]);
}
